const STORAGE_KEYS = {
  token: "rm_token",
  user: "rm_mock_user",
  orders: "rm_mock_orders",
  cartAdditions: "rm_mock_cart_additions",
  subscribers: "rm_mock_subscribers",
  quotes: "rm_mock_quotes",
  contacts: "rm_mock_contacts",
  registeredUsers: "rm_mock_registered_users",
};

import { Analytics } from "@/lib/analyticsShim";

const DEFAULT_ORDER_STATUS = "order_placed";

function normalizeOrderStatus(value) {
  const status = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  return ["order_placed", "processing", "dispatched", "delivered", "cancelled"].includes(status)
    ? status
    : DEFAULT_ORDER_STATUS;
}

function normalizeSentStatus(value) {
  const status = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  if (status === "new") return "not_sent";
  return ["sent", "not_sent"].includes(status) ? status : "not_sent";
}

function normalizeSubscriberStatus(value) {
  const status = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  return ["added", "not_added"].includes(status) ? status : "not_added";
}

const MOCK_USERS = [
  {
    id: "admin-1",
    email: "admin@railaxis.com",
    password: "admin123",
    name: "Admin",
    company: "RailAxis",
    role: "admin",
    phone: "",
    vendor_approved: true,
    approved_at: "2024-01-01T00:00:00.000Z",
    created_at: "2024-01-01T00:00:00.000Z",
  },
];

const PRODUCTS = [
  {
    id: "p1",
    slug: "steel-tmt",
    name: "Steel TMT Bars",
    category: "Steel",
    sizes: ["8mm", "10mm", "12mm", "16mm", "20mm", "25mm", "30mm", "40mm"],
    brands: ["Tata", "JSW", "SAIL"],
    locations: ["Mumbai", "Delhi", "Chennai"],
    base_price: 73000,
    image: "/assets/categories/steel.jpg",
    order: 0,
  },
  {
    id: "p2",
    slug: "cement",
    name: "Cement",
    category: "Cement",
    sizes: ["50kg Bag", "Bulk MT"],
    brands: ["UltraTech", "Ambuja", "ACC"],
    locations: ["Mumbai", "Delhi", "Kolkata"],
    base_price: 400,
    image: "/assets/categories/Cement.jpeg",
    order: 1,
  },
  {
    id: "p3",
    slug: "structural-steel",
    name: "Structural Steel",
    category: "Structural Steel",
    sizes: ["ISMB 100", "ISMB 150", "ISMB 200"],
    brands: ["Tata", "JSW", "Jindal"],
    locations: ["Mumbai", "Delhi", "Pune"],
    base_price: 78000,
    image:"/assets/categories/Structural_Steel.jpg",
    order: 2,
  },
  {
    id: "p4",
    slug: "pvc-pipes",
    name: "DI Pipes",
    category: "DI Pipes",
    sizes: ["20mm", "25mm", "32mm", "50mm"],
    brands: ["Finolex", "Supreme", "Astral"],
    locations: ["Mumbai", "Delhi", "Bangalore"],
    base_price: 180,
    image: "/assets/categories/DI_pipe.jpg",
    order: 3,
  },
  {
    id: "p1",
    slug: "Acc-block",
    name: "ACC Block",
    category: "Steel",
    sizes: ["8mm", "10mm", "12mm", "16mm", "20mm", "25mm", "30mm", "40mm"],
    brands: ["Tata", "JSW", "SAIL"],
    locations: ["Mumbai", "Delhi", "Chennai"],
    base_price: 73000,
    image: "/assets/categories/ACC Blocks.jpeg",
    order: 4,
  },
  {
    id: "p2",
    slug: "Tiles",
    name: "Tiles",
    category: "Cement",
    sizes: ["50kg Bag", "Bulk MT"],
    brands: ["UltraTech", "Ambuja", "ACC"],
    locations: ["Mumbai", "Delhi", "Kolkata"],
    base_price: 400,
    image: "/assets/categories/tiles.jpeg",
    order: 5,
  },
  // {
  //   id: "p3",
  //   slug: "Sanitary",
  //   name: "Sanitary",
  //   category: "Structural Steel",
  //   sizes: ["ISMB 100", "ISMB 150", "ISMB 200"],
  //   brands: ["Tata", "JSW", "Jindal"],
  //   locations: ["Mumbai", "Delhi", "Pune"],
  //   base_price: 78000,
  //   image:"/assets/categories/Sanitary.jpeg",
  //   order: 6,
  // },
  // {
  //   id: "p4",
  //   slug: "steel sheets",
  //   name: "Steel Sheets",
  //   category: "DI Pipes",
  //   sizes: ["20mm", "25mm", "32mm", "50mm"],
  //   brands: ["Finolex", "Supreme", "Astral"],
  //   locations: ["Mumbai", "Delhi", "Bangalore"],
  //   base_price: 180,
  //   image: "/assets/categories/Steek Sheets.jpeg",
  //   order: 7,
  // },
  // {
  //   id: "p1",
  //   slug: "bolts-nuts",
  //   name: "Bolts Nuts",
  //   category: "Steel",
  //   sizes: ["8mm", "10mm", "12mm", "16mm", "20mm", "25mm", "30mm", "40mm"],
  //   brands: ["Tata", "JSW", "SAIL"],
  //   locations: ["Mumbai", "Delhi", "Chennai"],
  //   base_price: 73000,
  //   image: "/assets/categories/Bolts-Nuts.jpg",
  //   order: 8,
  // },
  // {
  //   id: "p2",
  //   slug: "paint",
  //   name: "Paint",
  //   category: "Cement",
  //   sizes: ["50kg Bag", "Bulk MT"],
  //   brands: ["UltraTech", "Ambuja", "ACC"],
  //   locations: ["Mumbai", "Delhi", "Kolkata"],
  //   base_price: 400,
  //   image: "/assets/categories/Paint.jpg",
  //   order: 9,
  // },
  // {
  //   id: "p3",
  //   slug: "PVC-pipes",
  //   name: "PVC Pipes",
  //   category: "Structural Steel",
  //   sizes: ["ISMB 100", "ISMB 150", "ISMB 200"],
  //   brands: ["Tata", "JSW", "Jindal"],
  //   locations: ["Mumbai", "Delhi", "Pune"],
  //   base_price: 78000,
  //   image:"/assets/categories/PVC Pipes.jpeg",
  //   order: 10,
  // },
  // {
  //   id: "p4",
  //   slug: "Motors-Generators",
  //   name: "Motors Generators",
  //   category: "DI Pipes",
  //   sizes: ["20mm", "25mm", "32mm", "50mm"],
  //   brands: ["Finolex", "Supreme", "Astral"],
  //   locations: ["Mumbai", "Delhi", "Bangalore"],
  //   base_price: 180,
  //   image: "/assets/categories/Motors-Generators.jpeg",
  //   order: 11,
  // },
];

function nowIso() {
  return new Date().toISOString();
}

function loadJSON(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function saveJSON(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function buildError(detail, status = 400) {
  return {
    response: {
      status,
      data: { detail },
    },
    message: detail,
  };
}

function response(data) {
  return Promise.resolve({ data });
}

function getCurrentUser() {
  const token = localStorage.getItem(STORAGE_KEYS.token);
  if (!token) return null;
  return loadJSON(STORAGE_KEYS.user, null);
}

function loadRegisteredUsers() {
  return loadJSON(STORAGE_KEYS.registeredUsers, []);
}

function saveRegisteredUsers(users) {
  saveJSON(STORAGE_KEYS.registeredUsers, users);
}

function getAllUsers() {
  return [...MOCK_USERS, ...loadRegisteredUsers()];
}

function getPayloadValue(payload, key, fallback = "") {
  if (payload && typeof payload.get === "function") return payload.get(key) ?? fallback;
  return payload?.[key] ?? fallback;
}

function safeUser(user, token) {
  return {
    id: user.id,
    email: user.email,
    name: user.name,
    company: user.company || "",
    role: user.role,
    phone: user.phone || "",
    vendor_id: user.vendor_code || null,
    vendor_approved: user.role === "vendor" || user.role === "admin" ? Boolean(user.vendor_approved) : true,
    vendor_product_slug: user.vendor_product_slug || null,
    vendor_brand: user.vendor_brand || null,
    token,
  };
}

function requireMockAdmin() {
  const user = getCurrentUser();
  if (!user) throw buildError("Not authenticated", 401);
  if (user.role !== "admin") throw buildError("Admin access required", 403);
  if (!user.vendor_approved) throw buildError("Admin account is pending approval.", 403);
  return user;
}

function seedLocalState() {
  if (!localStorage.getItem(STORAGE_KEYS.orders)) saveJSON(STORAGE_KEYS.orders, []);
  if (!localStorage.getItem(STORAGE_KEYS.cartAdditions)) saveJSON(STORAGE_KEYS.cartAdditions, []);
  if (!localStorage.getItem(STORAGE_KEYS.subscribers)) saveJSON(STORAGE_KEYS.subscribers, []);
  if (!localStorage.getItem(STORAGE_KEYS.quotes)) saveJSON(STORAGE_KEYS.quotes, []);
  if (!localStorage.getItem(STORAGE_KEYS.contacts)) saveJSON(STORAGE_KEYS.contacts, []);
}

export function createMockApi() {
  seedLocalState();

  return {
    async get(path) {
      if (path === "/auth/me") {
        const user = getCurrentUser();
        if (!user) throw buildError("Not authenticated", 401);
        return response(user);
      }

      if (path === "/products") {
        return response(PRODUCTS);
      }

      if (path.startsWith("/products/")) {
        const slug = path.split("/products/")[1];
        const product = PRODUCTS.find((p) => p.slug === slug);
        if (!product) throw buildError("Product not found", 404);
        return response(product);
      }

      if (path === "/steel-prices") {
        return response({
          updated_at: nowIso(),
          prices: [
            { size: "8mm", brand: "JSW", price: 72000, unit: "MT" },
            { size: "10mm", brand: "Tata", price: 75000, unit: "MT" },
            { size: "12mm", brand: "SAIL", price: 73000, unit: "MT" },
          ],
        });
      }

      if (path === "/admin/admins") {
        const currentAdmin = requireMockAdmin();
        return response(getAllUsers()
          .filter((user) => user.role === "admin")
          .sort((a, b) => Number(Boolean(a.vendor_approved)) - Number(Boolean(b.vendor_approved)))
          .map((admin) => ({
            id: admin.id,
            name: admin.name || "Admin",
            company: admin.company || "RailAxis",
            email: admin.email || "",
            vendor_approved: Boolean(admin.vendor_approved),
            approved_at: admin.approved_at || null,
            created_at: admin.created_at || "",
            is_current_admin: admin.id === currentAdmin.id,
          })));
      }

      if (path === "/admin/vendors") {
        requireMockAdmin();
        return response(loadRegisteredUsers()
          .filter((user) => user.role === "vendor")
          .sort((a, b) => Number(Boolean(a.vendor_approved)) - Number(Boolean(b.vendor_approved)))
          .map((vendor) => ({
            id: vendor.id,
            name: vendor.name || "Vendor",
            company: vendor.company || "Vendor Company",
            phone: vendor.phone || "",
            email: vendor.email || "",
            vendor_code: vendor.vendor_code || "",
            vendor_approved: Boolean(vendor.vendor_approved),
            approved_at: vendor.approved_at || null,
            created_at: vendor.created_at || "",
            product_count: Number(vendor.product_count || 0),
            kyc_docs: {},
          })));
      }

      if (path.startsWith("/admin/vendors/") && path.endsWith("/products")) {
        requireMockAdmin();
        return response([]);
      }

      if (path === "/admin/quotes") {
        requireMockAdmin();
        return response(loadJSON(STORAGE_KEYS.quotes, []).slice().reverse().map((quote) => ({
          ...quote,
          status: normalizeSentStatus(quote.status),
        })));
      }

      if (path === "/admin/contacts") {
        requireMockAdmin();
        return response(loadJSON(STORAGE_KEYS.contacts, []).slice().reverse().map((contact) => ({
          ...contact,
          status: normalizeSentStatus(contact.status),
        })));
      }

      if (path === "/admin/subscribers") {
        requireMockAdmin();
        const subscribers = loadJSON(STORAGE_KEYS.subscribers, []);
        return response(subscribers.slice().reverse().map((subscriber, index) => (
          typeof subscriber === "string"
            ? { id: `sub-${index}`, email: subscriber, status: "not_added", created_at: "" }
            : { ...subscriber, status: normalizeSubscriberStatus(subscriber.status) }
        )));
      }

      if (path === "/admin/cart-additions") {
        requireMockAdmin();
        return response(loadJSON(STORAGE_KEYS.cartAdditions, []).slice().reverse());
      }

      if (path === "/admin/orders") {
        requireMockAdmin();
        const orders = loadJSON(STORAGE_KEYS.orders, []);
        return response(orders.map((order) => ({
          ...order,
          order_status: normalizeOrderStatus(order.order_status),
          contractor_name: order.contractor_name || "Contractor",
          contractor_company: order.contractor_company || "Contractor Company",
          contractor_phone: order.contractor_phone || "-",
          gst_amount: Number(order.gst || 0),
          gst_rate: 18,
          gst_input_done: Boolean(order.gst_input_done),
          payment_status: order.status === "paid" ? "done" : "not_done",
          items: order.items || [],
        })));
      }

      if (path === "/orders") {
        const user = getCurrentUser();
        if (!user) throw buildError("Not authenticated", 401);
        const orders = loadJSON(STORAGE_KEYS.orders, []);
        return response(orders
          .filter((o) => o.user_id === user.id)
          .map((o) => ({ ...o, order_status: normalizeOrderStatus(o.order_status) })));
      }

      if (path === "/orders/vendor") {
        const user = getCurrentUser();
        if (!user) throw buildError("Not authenticated", 401);
        if (user.role !== "vendor") throw buildError("Vendor access required", 403);
        const vendorKeys = [user.id, user.vendor_code].filter(Boolean).map(String);
        const orders = loadJSON(STORAGE_KEYS.orders, []);
        const vendorOrders = orders.flatMap((order) => {
          const items = (order.items || []).filter((item) => (
            [item.vendor_id].filter(Boolean).map(String).some((key) => vendorKeys.includes(key))
          ));
          if (!items.length) return [];
          const vendorSubtotal = items.reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0), 0);
          const vendorGst = Number((vendorSubtotal * 0.18).toFixed(2));
          return [{
            ...order,
            order_status: normalizeOrderStatus(order.order_status),
            contractor_name: order.contractor_name || "Contractor",
            contractor_company: order.contractor_company || "Contractor Company",
            contractor_phone: order.contractor_phone || "-",
            payment_status: order.status === "paid" ? "done" : "not_done",
            order_total: order.total,
            vendor_subtotal: vendorSubtotal,
            vendor_gst: vendorGst,
            vendor_total: Number((vendorSubtotal + vendorGst).toFixed(2)),
            items: items.map((item, idx) => ({
              ...item,
              id: item.id || `${order.id}-${idx}`,
              line_total: Number(item.price || 0) * Number(item.quantity || 0),
            })),
          }];
        });
        return response(vendorOrders);
      }

      throw buildError(`Mock GET endpoint not found: ${path}`, 404);
    },

    async post(path, payload = {}) {
      if (path === "/auth/login") {
        const email = (payload.email || "").toLowerCase().trim();
        const password = payload.password || "";

        const user = getAllUsers().find((u) => u.email === email && u.password === password);

        if (!user) throw buildError("Invalid email or password", 401);
        if (user.role === "admin" && !user.vendor_approved) {
          throw buildError("Admin account is pending approval.", 403);
        }

        const token = `mock-token-${user.id}`;
        localStorage.setItem(STORAGE_KEYS.token, token);
        const authUser = safeUser(user, token);
        saveJSON(STORAGE_KEYS.user, authUser);
        return response(authUser);
      }

      if (path === "/auth/register") {
        const requestedRole = String(getPayloadValue(payload, "role", "contractor")).toLowerCase().trim();
        const role = ["contractor", "vendor", "admin"].includes(requestedRole) ? requestedRole : "contractor";
        const email = String(getPayloadValue(payload, "email", "")).toLowerCase().trim();
        const password = String(getPayloadValue(payload, "password", ""));
        const name = String(getPayloadValue(payload, "name", "User")).trim() || "User";
        const company = String(getPayloadValue(payload, "company", "")).trim();
        const phone = String(getPayloadValue(payload, "phone", "")).replace(/\D/g, "").slice(0, 10);
        const createdAt = nowIso();

        const syntheticEmail = email || `${role}.${phone || Date.now()}@railaxis.local`;
        const registered = loadRegisteredUsers();
        const allUsers = getAllUsers();
        if (allUsers.some((u) => String(u.email || "").toLowerCase() === syntheticEmail)) {
          throw buildError("Email already registered", 400);
        }
        if (phone && allUsers.some((u) => u.role === role && u.phone === phone)) {
          throw buildError(`${role} already registered with this phone`, 400);
        }

        const user = {
          id: `user-${Date.now()}`,
          email: syntheticEmail,
          password,
          name,
          company,
          role,
          phone,
          vendor_code: role === "vendor" ? `VND-${Date.now().toString().slice(-6)}` : null,
          vendor_approved: role === "admin" || role === "vendor" ? false : true,
          approved_at: role === "contractor" ? createdAt : null,
          vendor_product_slug: role === "vendor" ? String(getPayloadValue(payload, "vendor_product_slug", "")) : null,
          vendor_brand: role === "vendor" ? String(getPayloadValue(payload, "vendor_brand", "")) : null,
          created_at: createdAt,
        };
        registered.push(user);
        saveRegisteredUsers(registered);

        return response({
          id: user.id,
          email: user.email,
          name: user.name,
          company: user.company,
          role: user.role,
          phone: user.phone,
          vendor_id: user.vendor_code,
          vendor_approved: user.role === "admin" || user.role === "vendor" ? false : true,
          vendor_product_slug: user.vendor_product_slug,
          vendor_brand: user.vendor_brand,
          message: user.role === "admin"
            ? "Admin account created. Waiting for approval before login."
            : user.role === "vendor"
              ? "Signup completed. Waiting for admin approval before vendor login."
              : "Signup completed. Please login with OTP.",
        });
      }

      if (path === "/auth/request-otp") {
        const role = String(payload.role || "").toLowerCase().trim();
        const company = String(payload.company || "").trim().toLowerCase();
        const phone = String(payload.phone || "").replace(/\D/g, "").slice(0, 10);
        const user = getAllUsers().find((candidate) => (
          candidate.role === role &&
          candidate.phone === phone &&
          String(candidate.company || "").trim().toLowerCase() === company
        ));

        if (!user) throw buildError("User not found. Please sign up first.", 404);
        if (role === "vendor" && !user.vendor_approved) {
          throw buildError("Vendor account is pending admin approval.", 403);
        }

        saveJSON("rm_mock_latest_otp", { user_id: user.id, otp: "123456", created_at: nowIso() });
        return response({ success: true, message: "OTP sent", dev_otp: "123456" });
      }

      if (path === "/auth/login-otp") {
        const role = String(payload.role || "").toLowerCase().trim();
        const company = String(payload.company || "").trim().toLowerCase();
        const phone = String(payload.phone || "").replace(/\D/g, "").slice(0, 10);
        const otp = String(payload.otp || "").trim();
        const user = getAllUsers().find((candidate) => (
          candidate.role === role &&
          candidate.phone === phone &&
          String(candidate.company || "").trim().toLowerCase() === company
        ));

        if (!user) throw buildError("User not found. Please sign up first.", 404);
        if (role === "vendor" && !user.vendor_approved) {
          throw buildError("Vendor account is pending admin approval.", 403);
        }
        const latestOtp = loadJSON("rm_mock_latest_otp", null);
        if (!latestOtp || latestOtp.user_id !== user.id) throw buildError("OTP not found. Request a new OTP.", 401);
        if (otp !== latestOtp.otp) throw buildError("Invalid OTP", 401);

        const token = `mock-token-${user.id}`;
        localStorage.setItem(STORAGE_KEYS.token, token);
        const authUser = safeUser(user, token);
        saveJSON(STORAGE_KEYS.user, authUser);
        return response(authUser);
      }

      if (path === "/auth/logout") {
        localStorage.removeItem(STORAGE_KEYS.token);
        localStorage.removeItem(STORAGE_KEYS.user);
        return response({ success: true });
      }

      if (path.startsWith("/admin/admins/") && path.endsWith("/approval")) {
        const currentAdmin = requireMockAdmin();
        const adminId = path.replace("/admin/admins/", "").replace("/approval", "");
        const approve = Boolean(payload.approve);
        const registered = loadRegisteredUsers();
        const registeredIndex = registered.findIndex((user) => user.id === adminId && user.role === "admin");
        const defaultAdmin = MOCK_USERS.find((user) => user.id === adminId && user.role === "admin");

        if (registeredIndex === -1 && !defaultAdmin) throw buildError("Admin not found", 404);
        if (!approve && adminId === currentAdmin.id) {
          throw buildError("You cannot move your own admin account to pending.", 400);
        }
        if (!approve && defaultAdmin) {
          throw buildError("Default admin cannot be moved to pending.", 400);
        }

        if (registeredIndex !== -1) {
          registered[registeredIndex] = {
            ...registered[registeredIndex],
            vendor_approved: approve,
            approved_at: approve ? nowIso() : null,
          };
          saveRegisteredUsers(registered);
        }

        return response({ success: true, admin_id: adminId, vendor_approved: approve });
      }

      if (path.startsWith("/admin/vendors/") && path.endsWith("/approval")) {
        requireMockAdmin();
        const vendorId = path.replace("/admin/vendors/", "").replace("/approval", "");
        const approve = Boolean(payload.approve);
        const registered = loadRegisteredUsers();
        const vendorIndex = registered.findIndex((user) => user.id === vendorId && user.role === "vendor");
        if (vendorIndex === -1) throw buildError("Vendor not found", 404);

        registered[vendorIndex] = {
          ...registered[vendorIndex],
          vendor_approved: approve,
          approved_at: approve ? nowIso() : null,
        };
        saveRegisteredUsers(registered);

        return response({ success: true, vendor_id: vendorId, vendor_approved: approve });
      }

      if (path === "/newsletter") {
        const email = (payload.email || "").toLowerCase().trim();
        if (!email) throw buildError("Email is required", 400);
        const subs = loadJSON(STORAGE_KEYS.subscribers, []);
        const exists = subs.some((subscriber) => (
          typeof subscriber === "string"
            ? subscriber === email
            : subscriber?.email === email
        ));
        if (!exists) {
          subs.push({ id: `sub-${Date.now()}`, email, status: "not_added", created_at: nowIso() });
          saveJSON(STORAGE_KEYS.subscribers, subs);
        }
        return response({ success: true, message: "Subscribed" });
      }

      if (path === "/quotes") {
        if (!payload.product || !payload.quantity || !payload.company || !payload.mobile) {
          throw buildError("product, quantity, company, and mobile are required", 400);
        }
        if (!Number.isFinite(Number(payload.quantity)) || Number(payload.quantity) <= 0) {
          throw buildError("quantity must be a positive number", 400);
        }
        if (payload.pincode && !/^\d{6}$/.test(String(payload.pincode))) {
          throw buildError("pincode must be a 6-digit number", 400);
        }
        if (!/^\d{10}$/.test(String(payload.mobile || ""))) {
          throw buildError("mobile must be a 10-digit number", 400);
        }
        const quotes = loadJSON(STORAGE_KEYS.quotes, []);
        const doc = { ...payload, id: `q-${Date.now()}`, status: "not_sent", created_at: nowIso() };
        quotes.push(doc);
        saveJSON(STORAGE_KEYS.quotes, quotes);
        return response(doc);
      }

      if (path === "/contact") {
        const contacts = loadJSON(STORAGE_KEYS.contacts, []);
        const doc = { ...payload, id: `c-${Date.now()}`, status: "not_sent", created_at: nowIso() };
        contacts.push(doc);
        saveJSON(STORAGE_KEYS.contacts, contacts);
        return response(doc);
      }

      if (path === "/cart/additions") {
        const user = getCurrentUser();
        if (!user) throw buildError("Not authenticated", 401);
        if (user.role !== "contractor") throw buildError("Only contractors can add cart items", 403);
        const cartAdditions = loadJSON(STORAGE_KEYS.cartAdditions, []);
        const doc = {
          ...payload,
          id: `cart-${Date.now()}-${cartAdditions.length}`,
          user_id: user.id,
          contractor_name: user.name || "Contractor",
          contractor_company: user.company || "Contractor Company",
          contractor_phone: user.phone || "-",
          contractor_email: user.email || "",
          created_at: nowIso(),
        };
        cartAdditions.push(doc);
        saveJSON(STORAGE_KEYS.cartAdditions, cartAdditions);
        return response({ success: true, id: doc.id, created_at: doc.created_at });
      }

      if (path === "/orders") {
        const user = getCurrentUser();
        if (!user) throw buildError("Not authenticated", 401);
        const items = payload.items || [];
        if (!items.length) throw buildError("Cart is empty", 400);

        const subtotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);
        const gst = Number((subtotal * 0.18).toFixed(2));
        const total = Number((subtotal + gst).toFixed(2));

        const order = {
          id: `o-${Date.now()}`,
          user_id: user.id,
          items,
          subtotal,
          gst,
          total,
          status: "pending_payment",
          order_status: DEFAULT_ORDER_STATUS,
          created_at: nowIso(),
        };

        const orders = loadJSON(STORAGE_KEYS.orders, []);
        orders.unshift(order);
        saveJSON(STORAGE_KEYS.orders, orders);
        return response(order);
      }

      if (path.startsWith("/orders/") && path.endsWith("/pay")) {
        const user = getCurrentUser();
        if (!user) throw buildError("Not authenticated", 401);

        const orderId = path.replace("/orders/", "").replace("/pay", "");
        const orders = loadJSON(STORAGE_KEYS.orders, []);
        const idx = orders.findIndex((o) => o.id === orderId && o.user_id === user.id);
        if (idx === -1) throw buildError("Order not found", 404);

        orders[idx] = { ...orders[idx], status: "paid", paid_at: nowIso() };
        saveJSON(STORAGE_KEYS.orders, orders);
        return response({ success: true, order_id: orderId, status: "paid" });
      }

      throw buildError(`Mock POST endpoint not found: ${path}`, 404);
    },

    async patch(path, payload = {}) {
      if (path.startsWith("/admin/quotes/") && path.endsWith("/status")) {
        requireMockAdmin();

        const quoteId = path.replace("/admin/quotes/", "").replace("/status", "");
        const quotes = loadJSON(STORAGE_KEYS.quotes, []);
        const idx = quotes.findIndex((quote) => quote.id === quoteId);
        if (idx === -1) throw buildError("Quote request not found", 404);

        const status = normalizeSentStatus(payload.status);
        quotes[idx] = { ...quotes[idx], status };
        saveJSON(STORAGE_KEYS.quotes, quotes);
        return response({ success: true, quote_id: quoteId, status });
      }

      if (path.startsWith("/admin/contacts/") && path.endsWith("/status")) {
        requireMockAdmin();

        const contactId = path.replace("/admin/contacts/", "").replace("/status", "");
        const contacts = loadJSON(STORAGE_KEYS.contacts, []);
        const idx = contacts.findIndex((contact) => contact.id === contactId);
        if (idx === -1) throw buildError("Contact information not found", 404);

        const status = normalizeSentStatus(payload.status);
        contacts[idx] = { ...contacts[idx], status };
        saveJSON(STORAGE_KEYS.contacts, contacts);
        return response({ success: true, contact_id: contactId, status });
      }

      if (path.startsWith("/admin/subscribers/") && path.endsWith("/status")) {
        requireMockAdmin();

        const subscriberId = path.replace("/admin/subscribers/", "").replace("/status", "");
        const subscribers = loadJSON(STORAGE_KEYS.subscribers, []);
        const idx = subscribers.findIndex((subscriber, index) => {
          if (typeof subscriber === "string") return `sub-${index}` === subscriberId;
          return subscriber.id === subscriberId;
        });
        if (idx === -1) throw buildError("Subscriber not found", 404);

        const status = normalizeSubscriberStatus(payload.status);
        const subscriber = subscribers[idx];
        subscribers[idx] = typeof subscriber === "string"
          ? { id: subscriberId, email: subscriber, status, created_at: "" }
          : { ...subscriber, status };
        saveJSON(STORAGE_KEYS.subscribers, subscribers);
        return response({ success: true, subscriber_id: subscriberId, status });
      }

      if (path.startsWith("/admin/orders/") && path.endsWith("/order-status")) {
        requireMockAdmin();

        const orderId = path.replace("/admin/orders/", "").replace("/order-status", "");
        const orders = loadJSON(STORAGE_KEYS.orders, []);
        const idx = orders.findIndex((order) => order.id === orderId);
        if (idx === -1) throw buildError("Order not found", 404);

        const orderStatus = normalizeOrderStatus(payload.order_status || payload.status);
        orders[idx] = { ...orders[idx], order_status: orderStatus };
        saveJSON(STORAGE_KEYS.orders, orders);
        return response({ success: true, order_id: orderId, order_status: orderStatus });
      }

      if (path.startsWith("/admin/orders/") && path.endsWith("/gst-status")) {
        requireMockAdmin();

        const orderId = path.replace("/admin/orders/", "").replace("/gst-status", "");
        const orders = loadJSON(STORAGE_KEYS.orders, []);
        const idx = orders.findIndex((order) => order.id === orderId);
        if (idx === -1) throw buildError("Order not found", 404);

        const done = Boolean(payload.done);
        orders[idx] = { ...orders[idx], gst_input_done: done };
        saveJSON(STORAGE_KEYS.orders, orders);
        return response({ success: true, order_id: orderId, gst_input_done: done });
      }

      throw buildError(`Mock PATCH endpoint not found: ${path}`, 404);
    },

    async delete(path) {
      if (path.startsWith("/admin/vendors/")) {
        requireMockAdmin();
        const vendorId = path.replace("/admin/vendors/", "");
        const registered = loadRegisteredUsers();
        const nextRegistered = registered.filter((user) => !(user.id === vendorId && user.role === "vendor"));
        if (nextRegistered.length === registered.length) throw buildError("Vendor not found", 404);
        saveRegisteredUsers(nextRegistered);
        return response({ success: true, vendor_id: vendorId });
      }

      throw buildError(`Mock DELETE endpoint not found: ${path}`, 404);
    },
  };
}
